import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef, entityPresentationApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/esm/useAsync';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { Team } from './Team';

export function useMyTeams(): Team[] {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);
  const entityPresentationApi = useApi(entityPresentationApiRef);

  const { value: groups } = useAsync(async () => {
    const profile = await identityApi.getBackstageIdentity();

    const response = await catalogApi.getEntities({
      filter: [
        {
          kind: 'group',
          'relations.hasMember': profile.userEntityRef,
        },
      ],
      fields: ['metadata', 'kind', 'spec.profile'],
    });
    return response.items;
  });

  if (!groups) return [];

  return groups.map(group => {
    return {
      name: entityPresentationApi.forEntity(group).snapshot.primaryTitle,
      entityRef: stringifyEntityRef(group),
    };
  });
}
